import { Pipe, PipeTransform } from '@angular/core';

import { TravelerItemUI } from '@pax/entities/pax-ui';
import { TravelerTypes } from '@pax/entities/traveler-info';

@Pipe({
  name: 'filterPassengerListUI',
  standalone: false
})
export class FilterPassengerListUIPipe implements PipeTransform {

  transform(passengerListUi: TravelerItemUI[], travelerType: TravelerTypes): TravelerItemUI[] {
    return passengerListUi.filter(passenger => passenger.TravelerType === travelerType);
  }
}
